import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { MdOutlineWifiOff } from 'react-icons/md';
import { VscLoading } from 'react-icons/vsc';

export const ConnectionStatusContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    // height: 24px;
    margin-top: -4px;
    margin-bottom: -4px;
    cursor: pointer;
`;

export const StatusItem = styled.div`
    // background-color: ${({ backgroundColor }) => backgroundColor || '#ffc107'};
    color: ${({ color }) => color || '#000'};
    width: 100%;
    text-align: center;
    // padding: 4px 16px;
    height: 100%;
`;

export const DisconnectedChat = () => {
    return (
        <div>
            <MdOutlineWifiOff size={60} />
            <h2 className="mb-4 mt-4">
                <b>Failed to connect.</b>
            </h2>
            <ActionButton variant="secondary" onClick={() => window.location.reload()}>
                Reload Page
            </ActionButton>
        </div>
    );
};

export const ActionButton = styled.button`
    background-color: ${({ variant }) => (variant === 'primary' ? '#50aeb0' : '#fff')};
    color: ${({ variant }) => (variant === 'primary' ? '#fff' : '#50aeb0')};
    border: 1px solid #50aeb0;
    font-weight: 500;
    padding: 0.5rem 1.25rem;
    font-size: 1.4rem;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        opacity: 0.9;
    }
`;

const SocketConnectionStatus = React.memo(({ connecting }) => {
    if (!connecting) {
        return null;
    }
    return (
        <Fragment>
            <ConnectionStatusContainer>
                <StatusItem>
                    <VscLoading className="spin mr-2" /> Waiting for connection...
                </StatusItem>
            </ConnectionStatusContainer>
        </Fragment>
    );
});
export default SocketConnectionStatus;
